export default __webpack_public_path__ + "static/media/me.358b519f.jpg";